module.exports = __webpack_public_path__ + "img/thumbnail_Mandrill_m_normal.2457de28.png";